/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `0` - 輸出
* `1` - 輸入
 */
export type TransportTypeEnum = typeof TransportTypeEnum[keyof typeof TransportTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportTypeEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
